export enum UploadsPermissions {
  GET_UPLOADS = 'uploads.getUploads',
  PERSIST_UPLOAD = 'uploads.persistUpload',
  DELETE_UPLOAD = 'uploads.deleteUpload',
  BULK_EXPORT = 'uploads.bulkExport',
}
